














































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import momentTz from 'moment-timezone';
import ReportModule from '@/store/modules/Report';
import MechanicReportModule from '@/store/modules/Mechanic';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import GameBody from '@/components/Table/GameBody.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import GameReportData from '@/data/GameReportData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GameReportBody from '@/components/Table/GameReportBody.vue';
import GameReportTypeBody from '@/components/Table/GameReportTypeBody.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    GameBody,
    GameReportBody,
    GameReportTypeBody,
  },
})
export default class MechanicReport extends Mixins(
  ToolMixin, ErrorHandleMixin,
) {
  ReportMechanicInstance = getModule(MechanicReportModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  Criteria = {
    ...this.Period,
  };

  gameType = 'total';

  TableHeadGameReport: any = [...GameReportData.TableHeadGameReport];

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  BreadcrumbList: any = [
    {
      type: 'amb',
      username: 'amb',
    },
  ];

  currentState = 'amb';

  previousState = 'amb';

  dataList: any = [];

  dataFooter: any[] = [];

  listProvider: any = [];

  provider = '';

  partnerType = 'all';

  partner = 'Provider';

  startDate = '';

  endDate = '';

  isFetchNewGameReport = true;

  isMulti = true;

  isMongo = true;

  isCoin = false;

  get stateBody() {
    if (['amb', 'provider'].includes(this.currentState)) return GameBody;
    if (this.currentState === 'type') return GameReportBody;
    else return GameReportTypeBody;
  }

  created() {
    this.fetchGame();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    this.startDate = this.$moment(this.Period.start.date)
      .startOf('day')
      .toDate();
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    this.endDate = this.$moment(this.Period.end.date)
      .endOf('day')
      .toDate();
  }

  handleMulti() {
    this.isMulti = !this.isMulti;
    this.fetchGame();
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    this.TableHeadGameReport = [...GameReportData.TableHeadGameReport];
    const partner = {
      partner: this.partnerType,
    };
    await this.GameInstance.FetchGame(partner);
    this.listProvider = this.GameInstance.game.partner;
    const criteria: any = {
      ...this.Period,
      gameType: this.gameType,
      state: this.currentState,
      provider: this.provider,
      isMulti: this.isMulti,
      isCoin: this.isCoin,
    };
    const res = await this.ReportMechanicInstance.GetMechanicReport(criteria);
    if (res.code) {
      this.checkError(res);
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type !== this.previousState);
      this.currentState = this.previousState;
      this.GeneralInstance.toggleLoading(false);
      return false;
    }
    if (this.currentState === 'amb') {
      this.dataList = { ...this.ReportMechanicInstance.dataGame.report };
      this.dataFooter = { ...this.ReportMechanicInstance.dataGame.footer };
      this.TableHeadGameReport[0][0].displayName = 'report.gameReport.datatable.number';
      this.TableHeadGameReport[0][1].displayName = `report.gameReport.datatable.${this.currentState}`;
    } else if (this.currentState === 'provider') {
      this.dataList = { ...this.ReportMechanicInstance.dataGame.report };
      this.dataFooter = { ...this.ReportMechanicInstance.dataGame.footer };
      this.TableHeadGameReport[0][1].displayName = `report.gameReport.datatable.${this.currentState}`;
    } else if (this.currentState === 'type') {
      const mapTable = [...GameReportData.TableHeadGameReport[0]];
      mapTable.join();
      mapTable.splice(1, 0, {
        displayName: 'report.gameReport.datatable.provider',
        attr: {
          class: 'text-center',
        },
      });
      this.TableHeadGameReport[0] = [...mapTable];
      this.TableHeadGameReport[0][0].displayName = 'report.gameReport.datatable.number';
      this.TableHeadGameReport[0][2].displayName = `report.gameReport.datatable.${this.currentState}`;
      this.dataList = { ...this.ReportMechanicInstance.dataGame.report };
      this.dataFooter = { ...this.ReportMechanicInstance.dataGame.footer };
    } else if (this.currentState === 'game') {
      const mapTable = [...GameReportData.TableHeadGameReport[0]];
      mapTable.join();
      mapTable.splice(1, 0, {
        displayName: 'report.gameReport.datatable.game',
        attr: {
          class: 'text-center',
        },
      });
      this.TableHeadGameReport[0] = [...mapTable];
      this.TableHeadGameReport[0][1].displayName = 'report.gameReport.datatable.type';
      this.TableHeadGameReport[0][2].displayName = 'report.gameReport.datatable.game';
      this.dataList = { ...this.ReportMechanicInstance.dataGame.report };
      this.dataFooter = { ...this.ReportMechanicInstance.dataGame.footer };
    }
    const START_DATE = momentTz(this.Period.start.date).format('YYYYMMDD');
    const END_DATE = momentTz(this.Period.end.date).format('YYYYMMDD');
    const NEW_GAME_REPORT_DATE = '20220524';
    const isFetchOldGameReport = (START_DATE < NEW_GAME_REPORT_DATE)
      && (END_DATE < NEW_GAME_REPORT_DATE);
    if (isFetchOldGameReport) this.isFetchNewGameReport = false;
    const arrDataList = Object.entries(this.dataList);
    for (let index = 0; index < arrDataList.length; index += 1) {
      const element = arrDataList[index];
      element.push(this.dataFooter[element[0]]);
    }
    arrDataList.sort((a, b) => b[2].total - a[2].total);
    this.dataList = Object.fromEntries(arrDataList);
    this.GeneralInstance.toggleLoading(false);
  }

  onSubmit() {
    this.fetchGame();
  }

  initial() {
    this.currentTool = 'Today';
    this.Period = {
      start: {
        date: this.$moment().startOf('day').toDate(),
      },
      end: {
        date: this.$moment().endOf('day').toDate(),
      },
    };
    this.Criteria = {
      ...this.Period,
    };
  }

  async handleBreadcrumb(item) {
    if (item.type === 'game') return false;
    if (item.type === 'provider') {
      this.TableHeadGameReport[0][0].displayName = 'report.gameReport.datatable.provider';
      this.currentState = 'type';
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type !== 'game');
    } else {
      this.currentState = item.type;
      this.BreadcrumbList = this.BreadcrumbList
        .filter((i) => i.type === item.type);
    }
    this.gameType = 'total';
    this.fetchGame();
  }

  handleSub(item, currentState) {
    this.previousState = currentState;
    if (currentState === 'amb') {
      this.currentState = 'provider';
    } else if (currentState === 'provider') {
      this.provider = item._id.product;
      this.BreadcrumbList.push({
        type: 'provider',
        username: item._id.product,
      });
      this.currentState = 'type';
    } else if (currentState === 'type') {
      this.gameType = item._id.category;
      this.BreadcrumbList.push({
        type: 'game',
        username: item._id.category,
      });
      this.currentState = 'game';
    }
    this.fetchGame();
  }
}
